import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from 'primevue/button';

import { useDownloadOffer } from '../composables/useDownloadOffer';
import { useCalculationPdfData } from '../composables/useCalculationPdfData';
import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useClientsStore } from '../store/clients';
import { buildCalculationFileName } from '../utils/calculationFileName';


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadOffer',
  setup(__props) {

const { getCompletePdfData } = useCalculationPdfData();
const { downloadOffer, isPending } = useDownloadOffer();
const { currentCalculation } = useCurrentCalculation();
const clientsStore = useClientsStore();

function handleClick() {
  const calculation = currentCalculation.value;
  const client = calculation?.client_uuid
    ? clientsStore.getClientByUuid(calculation.client_uuid)
    : null;

  const fileName = buildCalculationFileName({
    prefix: 'oferta',
    calculation,
    client,
  });

  downloadOffer(getCompletePdfData(), fileName);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: "font-semibold",
    severity: "secondary",
    outlined: "",
    size: "small",
    disabled: _unref(isPending),
    onClick: handleClick
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("i", { class: "pi pi-file-plus" }, null, -1),
      _createTextVNode(" Pobierz ofertę ")
    ])),
    _: 1
  }, 8, ["disabled"]))
}
}

})